import { defineMessages } from 'react-intl';

export const commonLabel = defineMessages({
    videos: 'Videos',
    articles: 'Articles',
    games: 'Games',
    quiz: 'Quiz',
    lesson: 'lesson',

    welcomeUser: 'Welcome, {user}',
});

export const commonButton = defineMessages({
    login: 'Login',
});

export const nationKindMessage = defineMessages({
    province: 'Province',
    district: 'District',
    village: 'Village',
});

export const expireKitplayMessage = defineMessages({
    notExpire: 'Expired',
    expireOneWeek: 'Expires within one week',
    expireTwoWeek: 'Expires within two weeks',
    expireOneMonth: 'Expires within one month',
    expireTwoMonth: 'Expires within two months',
});

